<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#4f2b1b">
      <path
        d="m48 15.84a38 38 0 0 0 -11.1 1.65c1.17 1 2.24 2.17 3.37 3.25a34.08 34.08 0 1 1 -26.27 34.4 27 27 0 0 1 -4-3v1.78a38.08 38.08 0 1 0 38-38.08z"
      />
      <path
        d="m23 33.64-6.87-7a.81.81 0 0 0 -1.25.16c-1.65 2.44-4.39 1.11-5.41-.7a.8.8 0 0 0 -1.25-.16l-6.78 7.41s0 0 0 0a.68.68 0 0 0 -.22.52c0 1.62 1.54 2.2 2.66 3.29 2.6 2.57 5.12 5.26 7.64 7.84a.8.8 0 0 0 1.12 0l10.36-10.24a.8.8 0 0 0 0-1.12z"
      />
      <path
        d="m47.13 34.14-10.58-10.41a.44.44 0 0 0 -.63 0l-10.2 10.43a.42.42 0 0 0 -.12.26s0 0 0 .07a.41.41 0 0 0 .13.3c2.53 2.53 5.36 7.4 9.29 7 1.89-.2 4.52-.46 6.22-1.42 2.17-1.21 4.14-3.88 5.9-5.59a.47.47 0 0 0 -.01-.64z"
      />
      <path
        d="m34.9 21.78-5.85-6.07a.82.82 0 0 0 -1.13 0l-3.34 2.88a.74.74 0 0 0 -.2.23.62.62 0 0 0 -.08.47c.09 4.25-.88 6.14-5.08 7.36a.8.8 0 0 0 -.35 1.35l4.78 5a.81.81 0 0 0 1.13 0l10.12-10.1a.82.82 0 0 0 0-1.12z"
      />
      <path
        d="m30.84 41.86-6-6a.39.39 0 0 0 -.29-.12h-.07a.41.41 0 0 0 -.28.12l-9 8.85a.45.45 0 0 0 .44.75l15-2.85a.45.45 0 0 0 .2-.75z"
      />
      <path
        d="m50.14 38-2.2-2.26a.46.46 0 0 0 -.64 0l-3.24 3.28a.33.33 0 0 0 -.16.21s0 .06 0 .1a.48.48 0 0 0 .2.4l.15.07a.54.54 0 0 0 .18 0l5.5-1.08a.46.46 0 0 0 .21-.72z"
      />
    </g>
    <path
      d="m56.76 50.86a6 6 0 0 0 -6.24-1c-2.52 1.14-3.1 3.72-3.52 6.19-2.41 0-4.78.35-6.28 2.51a5.72 5.72 0 0 0 -.29 5.93c1.32 2.43 4.16 3.4 6.71 3.86s7.68 1.1 10-.42c2-1.34 1.86-5.69 2.05-7.88.19-2.93-.07-7.05-2.43-9.19z"
      fill="#85c441"
    />
    <path
      d="m78.46 62.83c-.11-1.52-1.46-2.65-2.46-3.55-.29-.25-.56-.48-.79-.7l-5.41-5.36-2.33-2.33-7.69-7.69c-.41-.41-.85-.92-1.31-1.46-1.41-1.62-3-3.45-4.91-4-1.72-.53-3.86 0-5.74.5-.57.15-1.09.28-1.56.37l-10.64 2-6.84 1.29c-5 1-10 1.89-15 2.85l-.08-.08v.1l-1.22.23a2 2 0 0 0 -1.58 1.46 2.32 2.32 0 0 0 .53 2.32l39.41 39.41a2.22 2.22 0 0 0 1.57.65 2.29 2.29 0 0 0 1.59-.64c5-4.64 9.84-9.56 14.55-14.32 3-3 6.13-6.2 9.23-9.23a2.1 2.1 0 0 0 .4-.5 2.05 2.05 0 0 0 .28-1.32zm-46.4-17q7.65-1.44 15.28-2.9c5.46-1 8.92 2.69 12.58 6.64.75.81 1.5 1.63 2.27 2.4l5.6 5.59c.19.2.69.62 1.54 1.36 1 .87 3.08 2.65 4.11 3.68-2.72 2.69-5.44 5.4-8.07 8.1-4.19 4.23-8.5 8.59-12.89 12.76l-34.87-34.88z"
      fill="#85c441"
    />
  </svg>
</template>
